module.exports = __webpack_public_path__ + "img/img25.b2014062.jpg";